export class ClsConsultaModel {
  public NegoId: number;
  public Tipo: string;
  public UltmId: number;
  public Top: number;
  public Plataforma: string;
}
